/**
 * TUUFAM LUXURY STREETWEAR & HARDWARE GALLERY ENGINE (DESKTOP)
 * ─────────────────────────────────────────────────────────────
 * ✓ Strictly 3-Mode Segment Pill: [ ● ON HIM ] [ ALL LOOKS ] [ ● ON HER ]
 * ✓ ALL LOOKS Stage: Left = Him (-m-), Center = T-Shirt Details (-t-), Right = Her (-f-)
 * ✓ Seamless Auto-Switching: Clicking Him/Her Thumb instantly shifts mode
 * ✓ Slow Ambient Reel Float & TUUFAM Liquid Glass Specular Styling
 * ✓ TUUFAM Fit Guide Studio with Live [ IN | CM ] Switcher
 * ─────────────────────────────────────────────────────────────
 */
(() => {
  if (window.innerWidth <= 989) return; // Desktop only

  let globalActiveIndex = 0;
  let maleMedia = [];
  let femaleMedia = [];
  let detailMedia = [];
  let activeGenderFilter = 'all'; // 'all', 'him', 'her'

  const scrollSpeed = 0.25;
  let leftDir = 1;
  let rightDir = 1;
  let isHoveredLeft = false;
  let isHoveredRight = false;
  let animationFrameId = null;

  // --- PERSISTENT AMBIENT REEL ANIMATION ---
  const startReelAnimation = () => {
    if (animationFrameId) cancelAnimationFrame(animationFrameId);

    const step = () => {
      if (activeGenderFilter === 'all') {
        const leftC = document.querySelector('.tf-gallery-thumb-left');
        const rightC = document.querySelector('.tf-gallery-thumb-right');

        if (leftC && !isHoveredLeft && leftC.scrollHeight > leftC.clientHeight) {
          leftC.scrollTop += scrollSpeed * leftDir;
          if (leftC.scrollTop <= 0) leftDir = 1;
          if (leftC.scrollTop >= leftC.scrollHeight - leftC.clientHeight - 1) leftDir = -1;
        }

        if (rightC && !isHoveredRight && rightC.scrollHeight > rightC.clientHeight) {
          rightC.scrollTop += scrollSpeed * rightDir;
          if (rightC.scrollTop <= 0) rightDir = 1;
          if (rightC.scrollTop >= rightC.scrollHeight - rightC.clientHeight - 1) rightDir = -1;
        }
      }
      animationFrameId = requestAnimationFrame(step);
    };

    animationFrameId = requestAnimationFrame(step);
  };

  const parseProductImages = (mediaStack) => {
    if (maleMedia.length > 0 || femaleMedia.length > 0) return;

    const rawImages = mediaStack.querySelectorAll(':scope > img');
    rawImages.forEach((img) => {
      const src = img.getAttribute('src') || '';
      const alt = (img.getAttribute('alt') || '').trim().toLowerCase();
      const srcLower = src.toLowerCase();

      if (
        srcLower.includes('-m-') ||
        srcLower.includes('ow-m') ||
        srcLower.includes('pb-m') ||
        srcLower.includes('pl-m') ||
        alt.includes('male') ||
        alt.includes('men')
      ) {
        maleMedia.push({ src, alt, category: 'him' });
      } else if (
        srcLower.includes('-f-') ||
        srcLower.includes('ow-f') ||
        srcLower.includes('pb-f') ||
        srcLower.includes('pl-f') ||
        alt.includes('female') ||
        alt.includes('women')
      ) {
        femaleMedia.push({ src, alt, category: 'her' });
      } else {
        detailMedia.push({ src, alt, category: 'detail' });
      }
    });

    if (detailMedia.length === 0 && maleMedia.length > 0) {
      detailMedia.push(maleMedia[0]);
    }
  };

  const getActiveList = () => {
    if (activeGenderFilter === 'him') return maleMedia;
    if (activeGenderFilter === 'her') return femaleMedia;
    return detailMedia;
  };

  const rebuildTUUFAMGallery = () => {
    const mediaStack = document.querySelector('.tuufam-desktop-media-stack');
    if (!mediaStack) return;

    parseProductImages(mediaStack);

    // Clean up old elements
    const parent = mediaStack.parentNode;
    const oldFilter = parent.querySelector('.tuufam-model-filter-bar');
    if (oldFilter) oldFilter.remove();
    const oldLeftThumbs = mediaStack.querySelector('.tf-gallery-thumb-left');
    const oldRightThumbs = mediaStack.querySelector('.tf-gallery-thumb-right');
    const oldSideThumbs = mediaStack.querySelector('.tf-gallery-thumb-side');
    const oldViewport = mediaStack.querySelector('.tf-gallery-main-viewport');
    if (oldLeftThumbs) oldLeftThumbs.remove();
    if (oldRightThumbs) oldRightThumbs.remove();
    if (oldSideThumbs) oldSideThumbs.remove();
    if (oldViewport) oldViewport.remove();

    // 1. INJECT SEGMENT BAR
    const filterBar = document.createElement('div');
    filterBar.className = 'tuufam-model-filter-bar tf-desktop-filter';
    filterBar.innerHTML = `
      <button type="button" class="tf-filter-pill tf-filter-him ${activeGenderFilter === 'him' ? 'is-active' : ''}" data-filter="him">
        <span class="tf-dot-him"></span> ON HIM
      </button>
      <button type="button" class="tf-filter-pill tf-filter-all ${activeGenderFilter === 'all' ? 'is-active' : ''}" data-filter="all">
        ALL LOOKS
      </button>
      <button type="button" class="tf-filter-pill tf-filter-her ${activeGenderFilter === 'her' ? 'is-active' : ''}" data-filter="her">
        <span class="tf-dot-her"></span> ON HER
      </button>
    `;

    filterBar.querySelectorAll('.tf-filter-pill').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        activeGenderFilter = btn.dataset.filter;
        globalActiveIndex = 0;
        rebuildTUUFAMGallery();
      });
    });
    mediaStack.parentNode.insertBefore(filterBar, mediaStack);

    // 2. BUILD GALLERY STAGE
    if (activeGenderFilter === 'all') {
      mediaStack.classList.remove('tf-single-view-mode');

      // LEFT REEL: MALE PHOTOS
      const leftThumbContainer = document.createElement('div');
      leftThumbContainer.className = 'tf-gallery-thumb-container tf-gallery-thumb-left';
      leftThumbContainer.addEventListener('mouseenter', () => (isHoveredLeft = true));
      leftThumbContainer.addEventListener('mouseleave', () => (isHoveredLeft = false));

      maleMedia.forEach((mediaItem, idx) => {
        const thumbImg = document.createElement('img');
        thumbImg.src = mediaItem.src;
        thumbImg.alt = 'TUUFAM On Him';
        thumbImg.className = 'tf-gallery-thumb-item tf-thumb-male';
        thumbImg.addEventListener('click', () => {
          activeGenderFilter = 'him';
          globalActiveIndex = idx;
          rebuildTUUFAMGallery();
        });
        leftThumbContainer.appendChild(thumbImg);
      });

      // RIGHT REEL: FEMALE PHOTOS
      const rightThumbContainer = document.createElement('div');
      rightThumbContainer.className = 'tf-gallery-thumb-container tf-gallery-thumb-right';
      rightThumbContainer.addEventListener('mouseenter', () => (isHoveredRight = true));
      rightThumbContainer.addEventListener('mouseleave', () => (isHoveredRight = false));

      femaleMedia.forEach((mediaItem, idx) => {
        const thumbImg = document.createElement('img');
        thumbImg.src = mediaItem.src;
        thumbImg.alt = 'TUUFAM On Her';
        thumbImg.className = 'tf-gallery-thumb-item tf-thumb-female';
        thumbImg.addEventListener('click', () => {
          activeGenderFilter = 'her';
          globalActiveIndex = idx;
          rebuildTUUFAMGallery();
        });
        rightThumbContainer.appendChild(thumbImg);
      });

      // CENTER VIEWPORT: DETAIL SHOTS
      const mainViewport = document.createElement('div');
      mainViewport.className = 'tf-gallery-main-viewport';

      const mainImg = document.createElement('img');
      mainImg.className = 'tf-gallery-main-image';
      mainImg.src = detailMedia[globalActiveIndex] ? detailMedia[globalActiveIndex].src : (maleMedia[0] ? maleMedia[0].src : '');
      mainViewport.appendChild(mainImg);

      const prevBtn = document.createElement('div');
      prevBtn.className = 'tf-gallery-nav-btn tf-gallery-nav-prev';
      prevBtn.innerHTML = '&#10216;';
      prevBtn.addEventListener('click', (e) => { e.stopPropagation(); findNextImage(-1); });

      const nextBtn = document.createElement('div');
      nextBtn.className = 'tf-gallery-nav-btn tf-gallery-nav-next';
      nextBtn.innerHTML = '&#10217;';
      nextBtn.addEventListener('click', (e) => { e.stopPropagation(); findNextImage(1); });

      mainViewport.appendChild(prevBtn);
      mainViewport.appendChild(nextBtn);

      mediaStack.appendChild(leftThumbContainer);
      mediaStack.appendChild(mainViewport);
      mediaStack.appendChild(rightThumbContainer);
    } else {
      // SINGLE GENDER VIEW
      mediaStack.classList.add('tf-single-view-mode');
      const currentList = getActiveList();

      const sideThumbContainer = document.createElement('div');
      sideThumbContainer.className = 'tf-gallery-thumb-container tf-gallery-thumb-side';

      currentList.forEach((mediaItem, idx) => {
        const thumbImg = document.createElement('img');
        thumbImg.src = mediaItem.src;
        thumbImg.className = `tf-gallery-thumb-item ${idx === globalActiveIndex ? 'tf-active-thumb' : ''}`;
        thumbImg.addEventListener('click', () => {
          globalActiveIndex = idx;
          updateActiveDisplayState();
        });
        sideThumbContainer.appendChild(thumbImg);
      });

      const mainViewport = document.createElement('div');
      mainViewport.className = 'tf-gallery-main-viewport';

      const mainImg = document.createElement('img');
      mainImg.className = 'tf-gallery-main-image';
      mainImg.src = currentList[globalActiveIndex] ? currentList[globalActiveIndex].src : '';
      mainViewport.appendChild(mainImg);

      const prevBtn = document.createElement('div');
      prevBtn.className = 'tf-gallery-nav-btn tf-gallery-nav-prev';
      prevBtn.innerHTML = '&#10216;';
      prevBtn.addEventListener('click', (e) => { e.stopPropagation(); findNextImage(-1); });

      const nextBtn = document.createElement('div');
      nextBtn.className = 'tf-gallery-nav-btn tf-gallery-nav-next';
      nextBtn.innerHTML = '&#10217;';
      nextBtn.addEventListener('click', (e) => { e.stopPropagation(); findNextImage(1); });

      mainViewport.appendChild(prevBtn);
      mainViewport.appendChild(nextBtn);

      mediaStack.appendChild(sideThumbContainer);
      mediaStack.appendChild(mainViewport);
    }

    startReelAnimation();
  };

  const findNextImage = (direction) => {
    const currentList = getActiveList();
    if (!currentList.length) return;
    globalActiveIndex = (globalActiveIndex + direction + currentList.length) % currentList.length;
    updateActiveDisplayState();
  };

  const updateActiveDisplayState = () => {
    const mediaStack = document.querySelector('.tuufam-desktop-media-stack');
    const currentList = getActiveList();
    if (!mediaStack || !currentList.length) return;

    const mainImg = mediaStack.querySelector('.tf-gallery-main-image');
    if (mainImg && currentList[globalActiveIndex]) {
      mainImg.src = currentList[globalActiveIndex].src;
    }

    const thumbs = mediaStack.querySelectorAll('.tf-gallery-thumb-side .tf-gallery-thumb-item');
    thumbs.forEach((thumb, idx) => {
      thumb.classList.toggle('tf-active-thumb', idx === globalActiveIndex);
    });
  };

  // --- ALTERNATING COUPON GLOW ---
  const initCouponBreathing = () => {
    const cards = document.querySelectorAll('.tuufam-coupon-card');
    if (cards.length < 2) return;

    let activeCard = 0;
    setInterval(() => {
      cards.forEach((card, idx) => {
        card.classList.toggle('tf-coupon-active', idx === activeCard);
      });
      activeCard = (activeCard + 1) % cards.length;
    }, 2200);
  };

  // --- ACCORDION MUTEX ---
  const initAccordionMutex = () => {
    const accordions = document.querySelectorAll('.tuufam-accordion-item');
    accordions.forEach((targetDetail) => {
      targetDetail.addEventListener('toggle', () => {
        if (targetDetail.open) {
          accordions.forEach((otherDetail) => {
            if (otherDetail !== targetDetail && otherDetail.open) otherDetail.open = false;
          });
        }
      });
    });
  };

  // --- REAL-TIME LIVE STOCK & TACTILE SIZE ENGINE ---
  const initSizeAndStockTracker = () => {
    const updateInventoryDisplay = () => {
      const inventoryEl = document.querySelector('.product__inventory');
      if (!inventoryEl) return;

      const text = (inventoryEl.textContent || '').toLowerCase();
      const numMatch = text.match(/\d+/);
      const qty = numMatch ? parseInt(numMatch[0], 10) : 0;

      if (text.includes('low') || text.includes('left') || (qty > 0 && qty <= 3)) {
        inventoryEl.innerHTML = `
          <span class="tf-radar-pulse tf-radar-amber"></span>
          <span class="tf-stock-text">LOW STOCK · ONLY ${qty > 0 ? qty : 2} COMBOS LEFT (BATCH 01)</span>
        `;
      } else if (text.includes('out of stock') || text.includes('sold out')) {
        inventoryEl.innerHTML = `
          <span class="tf-radar-pulse tf-radar-muted"></span>
          <span class="tf-stock-text">SIZE CURRENTLY SOLD OUT · JOIN RESTOCK NOTIFY</span>
        `;
      } else {
        inventoryEl.innerHTML = `
          <span class="tf-radar-pulse tf-radar-emerald"></span>
          <span class="tf-stock-text">BATCH 01 · READY FOR EXPRESS DISPATCH</span>
        `;
      }
    };

    document.querySelectorAll('.product-form__input input[type="radio"], variant-radios input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => {
        setTimeout(updateInventoryDisplay, 150);
      });
    });

    updateInventoryDisplay();
  };

  // --- TUUFAM CAD FIT GUIDE & UNIT SWITCHER LOGIC ---
  const initFitGuideEngine = () => {
    const modal = document.getElementById('tuufam-size-modal');
    const openBtns = document.querySelectorAll('.tf-fit-guide-btn, [data-open-size-chart], .product-popup-modal__opener, .product-form__input .form__label button, [href="#size-chart"]');
    if (!modal) return;

    const closeBtn = modal.querySelector('.tuufam-modal-close-btn');
    const unitBtns = modal.querySelectorAll('.tf-unit-btn');
    const tableRows = modal.querySelectorAll('.tuufam-size-table tbody tr');

    const openModal = (e) => {
      if (e) e.preventDefault();
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    };

    openBtns.forEach((btn) => btn.addEventListener('click', openModal));
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

    // Unit Switcher (IN vs CM)
    unitBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        unitBtns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        const unit = btn.dataset.unit;
        modal.querySelectorAll('.tf-unit-label').forEach((el) => (el.textContent = unit.toUpperCase()));

        tableRows.forEach((row) => {
          const values = (row.dataset[unit] || '').split(',');
          if (values.length === 3) {
            row.querySelector('.tf-c').textContent = values[0];
            row.querySelector('.tf-l').textContent = values[1];
            row.querySelector('.tf-s').textContent = values[2];
          }
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    rebuildTUUFAMGallery();
    initAccordionMutex();
    initCouponBreathing();
    initSizeAndStockTracker();
    initFitGuideEngine();
  });
})();